import { ParsedUrlQuery } from 'querystring';

const saleQueryParams: ParsedUrlQuery = {
    view_type: 'list',
    section: 'for-sale'
};
const rentQueryParams: ParsedUrlQuery = {
    price_frequency: 'per_month',
    view_type: 'list',
    section: 'to-rent'
};
const housePricesQueryParams: ParsedUrlQuery = {
    section: 'house-prices'
};

export const content = {
    saleQueryParams: saleQueryParams,
    rentQueryParams: rentQueryParams,
    housePricesQueryParams: housePricesQueryParams,
    missingSearchAreaError: 'Please enter a valid search area',
    searchAreaPlaceholder: 'e.g. Oxford or NW3',
    searchAreaLabel: 'Search area'
};
